import React, { useEffect, useState } from "react";
// import SponsorSlider from '../../components/sponsorSlider/SponsorSlider'
// import UserStat from '../../components//UserStat'

import "./mobileProfile.css";

import SponsorSlider from "../../components/sponsorSlider/SponsorSlider";
import UserStat from "../../components/userStat/UserStat";
import UserInfo from "./components/userInfo/UserInfo";
import MatchInfo from "./components/matchInfo/MatchInfo";
import ShareProfile from "./components/shareProfile/ShareProfile";
import ProfileMenu from "./components/profileMenu/ProfileMenu";
import GoldenBallPromo from "./components/goldenBallPromo/GoldenBallPromo";

import {
  clickLog,
  offerEligibility,
  userDetails,
  userProfileUpdate,
} from "../../services/MainApiDetails";

import { useSelector, useDispatch } from "react-redux";
import image from "../../utilities/constants.json";
import { User } from "../../actions";
import { Link } from "react-router-dom";
import LanguageSwitch from "../settings/components/LanguageSwitch";

const MobileProfile = () => {
  const [offerEligible, setOfferEligible] = useState(null);

  const isLogin = useSelector((state) => state.isLogged);
  const userProfile = useSelector((state) => state.userData.items);
  const [proImage, setProImage] = useState(image.profile_image);
  const [otherData, setOtherData] = useState();
  const dispatch = useDispatch();
  useEffect(() => {
    // if (localStorage.webKey) {
    eligibility();
    getUserDetails();
    // }
  }, []);

  function eligibility() {
    offerEligibility({})
      .then((res) => {
        if (res.data.status == 1) {
          setOfferEligible(1);
        } else {
          setOfferEligible(0);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  function getUserDetails() {
    // if ((userProfile.length ==0)  && localStorage.webKey) {
    userDetails().then((response) => {
      if (response.data.status === 1) {
        setOtherData(response.data);
        setOtherData(response.data);
        setOtherData(response.data);
        dispatch(User(response.data.user_data));
        console.log(userProfile);
      }
    });

    // console.log(userProfile)
  }

  // Language Switching
  function changeLanguage(value) {
    userProfileUpdate({
      language: value,
    })
      .then((res) => {
        if (res.data.status) {
          localStorage.setItem("language", value);
          window.location.reload();
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // Responsive menu
  const [windowDimension, setWindowDimension] = useState(null);

  useEffect(() => {
    setWindowDimension(window.innerWidth);
  }, []);

  useEffect(() => {
    function handleResize() {
      setWindowDimension(window.innerWidth);
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowDimension <= 640;
  // Responsive menu
  function getClickEn() {
    clickLog({})
      .then((res) => {})
      .catch((e) => {
        console.log(e);
      });
  }
return (
  <div className="mobileProfile">
    <GoldenBallPromo />
    <div className="container">
      <div className="row">
        <>
          <UserInfo
            userProfile={userProfile}
            proImage={proImage}
            matchProfile={otherData ? otherData.game_profile : ""}
            otherData={otherData ? otherData : ""}
          />
          <MatchInfo
            matchProfile={otherData ? otherData.game_profile : ""}
            scoreProfile={otherData ? otherData.score_profile : ""}
          />

          {isMobile ? (
              <LanguageSwitch changeLanguage={changeLanguage} />
          ) : ""}
        </>
      </div>
    </div>

    {isMobile && offerEligible !== null && (
      <ShareProfile
        type={offerEligible}
        matchProfile={otherData ? otherData.game_profile : ""}
        scoreProfile={otherData ? otherData.score_profile : ""}
      />
    )}

    {isMobile && (
      <div className="container">
        <div className="row">
          <ProfileMenu
            otherData={otherData}
            matchProfile={otherData ? otherData.game_profile : ""}
            scoreProfile={otherData ? otherData.score_profile : ""}
          />
          <div className="poweredBy-playspots-wrapper">
            <div className="text">
              <p>
                <Link to="/playspots">Developed by PlaySpots</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    )}
  </div>
);
};

export default MobileProfile;
